import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { AccessSolicitudCpeViewModel } from '../../../_importacion/solicitudes/types/enum';
import { BASE_URL_SERVICE } from 'src/app/app.module';

export function AccessSolicitudExCpeGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudCpe', id);

            return http.get<boolean>(baseUrl + 'api/exportacion/cpes/main/accessSolicitud/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

/**
 * Actualmente sin uso
 * @returns CanActivateFn
 */
export function AccessSolicitanteExCpeGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const id = route.paramMap.get('id');

        if (id) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudCpe', route.parent!.paramMap.get('id')!);
            params = params.append('idSolicitante', id);

            return http.get<boolean>(baseUrl + 'api/exportacion/cpes/main/accessSolicitante/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessProductoExCpeGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idProd = route.paramMap.get('idprod');

        if (idProd) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudCpe', route.parent!.paramMap.get('id')!);
            params = params.append('idProductoCpe', idProd);

            return http.get<boolean>(baseUrl + 'api/exportacion/cpes/main/accessProducto/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function AccessDocumentosExCpeGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const idDocumento = route.paramMap.get('idDocumento');

        if (idDocumento) {
            const http = inject(HttpClient);
            const baseUrl = inject(BASE_URL_SERVICE);
            const router = inject(Router);
            const authService = inject(AuthService);
            let params = new HttpParams();
            params = params.append('idUsuario', authService.getLoggedInUser()!.Id.toString());
            params = params.append('idSolicitudCpe', route.parent!.paramMap.get('id')!);
            params = params.append('idDocumento', idDocumento);

            return http.get<boolean>(baseUrl + 'api/exportacion/cpes/main/accessDocumento/', { params: params }).pipe(
                map(res => {
                    if (res) {
                        return true;
                    } else {
                        console.error('You are not allowed to see this page');
                        router.navigate(['/']);
                        return false;
                    }
                }),
            );
        } else {
            console.error('You are not allowed to see this page');
            return false;
        }
    };
}

export function ActionEstadoExCpeGuard(): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        let idSolicitudCpe = route.paramMap.get('id');

        if (!idSolicitudCpe) {
            // route.parent!.paramMap.get('idSolicitudCpe')!;
            console.error('You are not allowed to see this page');
            return false;
        }

        const http = inject(HttpClient);
        const baseUrl = inject(BASE_URL_SERVICE);
        const router = inject(Router);
        const authService = inject(AuthService);

        let user = authService.getLoggedInUser()!;
        let params = new HttpParams();
        params = params.append('idSolicitudCpe', idSolicitudCpe);

        return http.get<AccessSolicitudCpeViewModel>(baseUrl + 'api/exportacion/cpes/main/idEstadoSolicitudCpe/', { params: params }).pipe(
            map(res => {
                if (user.getAction(route.data.actionCode, res.IdEstadoSolicitudCpe).Visible) {
                    return true;
                } else {
                    console.error('You are not allowed to see this page');
                    router.navigate(['/']);
                    return false;
                }
            }),
        );
    };
}
